import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { mapArrayElement } from "../../../helpers";
export function mapBet(bets) {
    return bets.map(bet => ({
        betId: bet[0],
        receiptId: bet[1],
        type: bet[2],
        status: bet[3],
        settlementStatus: bet[4],
        numberOfBets: bet[5],
        numberOfSelections: bet[6],
        displayOdds: bet[7],
        currency: bet[8],
        placementDate: bet[9],
        settlementDate: bet[10],
        stake: bet[11],
        potentialReturns: bet[12],
        returns: bet[13],
        bonus: mapArrayElement(bet[14], mapBonus),
        selections: bet[15].map(selection => mapSelection(selection)),
        combinations: mapCombinations(bet[16]),
        progressiveParlay: mapArrayElement(bet[17], mapProgressiveParlay),
        replayData: mapArrayElement(bet[21], mapBetReplayData),
        tags: mapArrayElement(bet[23], mapTags),
        originalDisplayOdds: getTruthyValue(bet[24], undefined),
        earlyExitStatus: getTruthyValue(bet[25], undefined),
    }));
}
export function mapCombinations(combinations) {
    return combinations.map(combinationData => ({
        id: combinationData[0],
        selectionsMapped: combinationData[1],
        trueOdds: combinationData[2],
        displayOdds: combinationData[3],
        potentialReturns: combinationData[4],
        actualReturns: combinationData[5],
        status: combinationData[6],
        maxComboBonusWinningsAmount: combinationData[7],
        comboBonusWinningsAmount: combinationData[8],
    }));
}
function mapSelection(selection) {
    return {
        selectionId: selection[0],
        eventId: selection[1],
        marketId: selection[2],
        status: selection[3],
        settlementStatus: selection[4],
        displayOdds: selection[5],
        selectionDisplayName: selection[6],
        marketDisplayName: selection[7],
        isInBetBoost: selection[8],
        marketBlurb: mapArrayElement(selection[9], mapMarketBlurb),
        gameScore: selection[10],
        nestedSGPSelections: mapArrayElement(selection[11], mapNestedSGPSelections),
        isEarlyWinSettled: selection[12],
        pointsMetadata: getTruthyValue(mapArrayElement(selection[13], mapPointsMetaData), undefined),
        replayData: getTruthyValue(mapArrayElement(selection[14], mapSelectionReplayData), undefined),
        tags: mapArrayElement(selection[15], mapTags),
        isEarlyExitApplied: getTruthyValue(selection[18], undefined),
        isEarlyWinEligible: getTruthyValue(selection[19], undefined),
    };
}
export function mapTags(tags) {
    return tags === null || tags === void 0 ? void 0 : tags.map(tag => tag);
}
export function mapNestedSGPSelections(selections) {
    return selections.map(nestedSGPSelection => mapSelection(nestedSGPSelection));
}
export function mapBonus(bonus) {
    return {
        bonusId: bonus[0],
        bonusType: bonus[1],
        earlyWinToken: bonus[2],
        freeBetAmount: +bonus[3],
        boostStatus: bonus[7],
        boostSelections: bonus[8],
        boostDisplayOdds: bonus[10],
        boostOriginalOdds: bonus[11],
        boostMaxReturns: +bonus[12],
        boostReturns: +bonus[14],
        boostType: bonus[15],
        boostValue: +bonus[16],
        boostOriginalValue: +bonus[17],
        qualifyingBetType: bonus[18]
    };
}
export function mapMarketBlurb(blurb) {
    return {
        id: blurb[0],
        text: blurb[1]
    };
}
export function mapPointsMetaData(pointsMetaData) {
    return {
        targetUnderPoints: getTruthyValue(pointsMetaData[0], undefined),
        targetOverPoints: getTruthyValue(pointsMetaData[1], undefined),
        currentTotalPoints: getTruthyValue(pointsMetaData[2], undefined)
    };
}
export function mapProgressiveParlay(parlays) {
    return parlays.map((parlay) => ({
        numberOfSelections: parlay[0],
        returns: parlay[1],
        displayOdds: parlay[2],
        trueOdds: parlay[3]
    }));
}
export function mapBetReplayData(betReplayData) {
    return {
        homeTeamName: betReplayData[0],
        awayTeamName: betReplayData[1],
        pitcherName: betReplayData[2],
        batterName: betReplayData[3],
        startEventDate: betReplayData[4],
        inningNumber: betReplayData[5],
        inningHalf: betReplayData[6],
        atBatNumber: betReplayData[7],
    };
}
export function mapSelectionReplayData(selectionReplayData) {
    return {
        pitchNumber: selectionReplayData[0],
    };
}
//# sourceMappingURL=mapBet.js.map